<div class="space"></div>

<div class="lightgray">
	<div class="slider">
		<div class="slide">
			<div class="somos">
				<div class="wrapper">
					<div class="info anime-element fadeleft-animation">
						<h2>{{ 'cloud.title34' | translate }}</h2>
						<h3>{{ 'cloud.title35' | translate }}</h3>
						<h4>{{ 'cloud.title36' | translate }}</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="space3"></div>

<div id="primary" class="content-area">
	<div class="wrap">
		<section class="vc-section">
			<div class="section-header">
				<div class="wpb_column vc_column_container" style="flex: 0 1 100%;">
					<div class="vc-column">
						<h3>{{ 'cloud.title37' | translate }}</h3>
						<p></p>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>


<div class="content-area barra">
	<div class="wrap">

		<section class="preguntas">

			<div class="flex6 website">
				<div class="elementb box">
					<div class="high">
						<div class="table">
							<div class="cell figure">
							    <span>01</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title38' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<div class="table">
							<div class="cell figure">
							    <span>02</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title39' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<div class="table">
							<div class="cell figure">
							    <span>03</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title40' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<div class="table">
							<div class="cell figure">
							    <span>04</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title41' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<div class="table">
							<div class="cell figure">
							    <span>05</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title42' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<div class="table">
							<div class="cell figure">
							    <span>06</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title43' | translate }}</h3>
					</div>
				</div>

			</div>
		</section>

	</div>
</div>

<div class="space"></div>



<div class="darkblue">
<div class="content-area">
	<div class="wrap">

		<section id="servicios">
		    <div class="wrapper">
		        <div class="two-col">
		            <div class="graph">
		                <div [ngClass]="{'active' : service === 'cloud'}" class="service">
		                    <img class="main" src="../../../../assets/img/cloud/cmain.svg" alt="documents">
		                    <img class="bubble-1" src="../../../../assets/img/cloud/scloud-01.svg" alt="bubble">
		                    <img class="bubble-2" src="../../../../assets/img/cloud/lock.svg" alt="bubble">
		                    <img class="l-bubble-1" src="https://static.amarello.cloud/img/anteater/website/l-bubble%201.svg" alt="bubble">
		                    <img class="l-bubble-2" src="https://static.amarello.cloud/img/anteater/website/l-bubble%202.svg" alt="bubble">
		                </div> 
		                <div [ngClass]="{'active' : service === 'education'}" class="service">
		                    <img class="main" src="../../../../assets/img/cloud/w-mail.svg" alt="documents">
		                    <img class="bubble-1" src="../../../../assets/img/cloud/w-calendar.svg" alt="bubble">
		                    <img class="bubble-2" src="../../../../assets/img/cloud/w-drive.svg" alt="bubble">
		                    <img class="l-bubble-1" src="https://static.amarello.cloud/img/anteater/ecommerce/l-bubble%201.svg" alt="bubble">
		                    <img class="l-bubble-2" src="https://static.amarello.cloud/img/anteater/ecommerce/l-bubble%202.svg" alt="bubble">
		                </div> 
		                <div [ngClass]="{'active' : service === 'implement'}" class="service">
		                    <img class="main" src="../../../../assets/img/cloud/c-medida2.svg" alt="documents">
		                    <img class="bubble-1" src="../../../../assets/img/cloud/c-medida.svg" alt="bubble">
		                    <img class="bubble-2" src="../../../../assets/img/cloud/c-medida3.svg" alt="bubble">
		                    <img class="l-bubble-1" src="https://static.amarello.cloud/img/anteater/documents/l-bubble%201.svg" alt="bubble">
		                    <img class="l-bubble-2" src="https://static.amarello.cloud/img/anteater/documents/l-bubble%202.svg" alt="bubble">
		                </div> 
		                <div [ngClass]="{'active' : service === 'join'}" class="service">
		                    <img class="main" src="../../../../assets/img/cloud/join2.svg" alt="documents">
		                    <img class="bubble-1" src="../../../../assets/img/cloud/join.svg" alt="bubble">
		                    <img class="bubble-2" src="../../../../assets/img/cloud/join3.svg" alt="bubble">
		                    <img class="l-bubble-1" src="https://static.amarello.cloud/img/anteater/documents/l-bubble%201.svg" alt="bubble">
		                    <img class="l-bubble-2" src="https://static.amarello.cloud/img/anteater/documents/l-bubble%202.svg" alt="bubble">
		                </div> 
		            </div>
		            <div class="info">
		                <h3>{{ 'cloud.title44' | translate }}</h3>
		                <div [ngClass]="{'active' : service === 'cloud'}" class="service e-commerce">
		                    <h4>{{ 'cloud.title45' | translate }}</h4> 
		                    <p>{{ 'cloud.title46' | translate }}</p>
		                </div>
		                <div [ngClass]="{'active' : service === 'education'}" class="service e-commerce">
		                    <h4>{{ 'cloud.title47' | translate }}</h4>
		                    <p>{{ 'cloud.title48' | translate }}</p>
		                </div>
		                <div [ngClass]="{'active' : service === 'implement'}" class="service e-commerce">
		                    <h4>{{ 'cloud.title49' | translate }}</h4>
		                    <p>{{ 'cloud.title50' | translate }}</p>
		                </div>
		                <div [ngClass]="{'active' : service === 'join'}" class="service e-commerce">
		                    <h4>{{ 'cloud.title51' | translate }}</h4>
		                    <p>{{ 'cloud.title52' | translate }}</p>
		                </div>
		            </div>
		        </div>
		    </div>
		</section>

	</div>
</div>
</div>

<div class="space"></div>



<div class="cleargray">
<div id="primary" class="content-area">
	<div class="wrap">
		<section class="vc-section">
			<div class="section-header2">
				<div class="wp_column vs_column_container">
					<div class="vs-column">
						<h2>{{ 'cloud.title53' | translate }}</h2>
						<p></p>
					</div>
				</div>
				<div class="wp_column vs_column_container">
					<div class="vs-column move" style="padding: 0;">
						<div class="box8">
							<img class="badge" src="../../../../assets/img/gpartner1.webp" alt="google cloud partner">
						</div>
						<div class="box8">
							<img class="badge" src="../../../../assets/img/Work_Transformation.webp" alt="work transformation">
						</div>
						<div class="box8">
							<img class="badge" src="../../../../assets/img/microsoft.webp" alt="microsoft partner">
						</div>

					</div>
				</div>
			</div>
		</section>


		<section id="ventajas">
			<div class="box2">
				<div class="flex">
					<div class="col">
						<div class="elast">
							<div class="bar">
								<img class="flag" src="../../../../assets/img/star.svg" alt="star">
							</div>
							<div class="bar">
								<h2>{{ 'cloud.title54' | translate }}</h2>
								<h3>{{ 'cloud.title55' | translate }}</h3>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="elast">
							<div class="bar">
								<img class="flag" src="../../../../assets/img/trust.svg" alt="trust">
							</div>
							<div class="bar">
								<h2>{{ 'cloud.title56' | translate }}</h2>
								<h3>{{ 'cloud.title57' | translate }}</h3>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="elast">

							<div class="bar">
								<img class="flag" src="../../../../assets/img/success.svg" alt="success">
							</div>
							<div class="bar">
								<h2>{{ 'cloud.title58' | translate }}</h2>
								<h3>{{ 'cloud.title59' | translate }}</h3>
							</div>



							
						</div>
					</div>
					<div class="col">
						<div class="elast">
							<div class="bar">
								<img class="flag" src="../../../../assets/img/cup.svg" alt="flag">
							</div>
							<div class="bar">
								<h2>{{ 'cloud.title60' | translate }}</h2>
								<h3>{{ 'cloud.title61' | translate }}</h3>
							</div>
						</div>
					</div>
					
				</div>
			</div>



			

			<div class="box21">
				<div class="flex21">
					<div class="col2">
						<div class="elast2">
							<div class="bar2">
								<img class="flag" src="../../../../assets/img/team.svg" alt="team">
							</div>
							<div class="bar2">
								<h2>{{ 'cloud.title62' | translate }}</h2>
								<h3>{{ 'cloud.title63' | translate }}</h3>
							</div>
						</div>
					</div>
					<div class="col2">
						<div class="elast2">
							<div class="bar2">
								<img class="flag" src="../../../../assets/img/join2.svg" alt="join">
							</div>
							<div class="bar2">
								<h2>{{ 'cloud.title64' | translate }}</h2>
								<h3>{{ 'cloud.title65' | translate }}</h3>
							</div>
						</div>
					</div>
					<div class="col2">
						<div class="elast2">
							<div class="bar2">
								<img class="flag" src="../../../../assets/img/certuficate.svg" alt="certificate">
							</div>
							<div class="bar2">
								<h2>{{ 'cloud.title66' | translate }}</h2>
								<h3>{{ 'cloud.title67' | translate }}</h3>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="space3"></div>		

		</section>
	</div>
</div>
</div>

<div class="space2"></div>

<div class="fondo9">
	<div class="content-area">
		<div class="wrap">
			<div class="fluid9">
				<img class="aro" id="loading" src="../../../../assets/img/aro.webp" alt="aro">
				<div class="white">
					<div class="box10">
						<div class="inner">
							<img class="gocloud" src="../../../../assets/img/gocloud.svg" alt="cloud">
							<h3>Google Cloud<br>Partner of the year</h3>
							<p>{{ 'cloud.title68' | translate }}</p>
						</div>
					</div>
				</div>
				<div class="white">
					<div class="box10">
						<div class="inner">
							<img class="gocloud" src="../../../../assets/img/gocloud.svg" alt="cloud">
							<h3>Google Cloud<br>Partner of the year</h3>
							<p>Infrastructure Customer Journey.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div id="primary" class="content-area">
	<div class="wrap">
		<section class="vc-section">
			<div class="section-header">
				<div class="wpb_column vc_column_container">
					<div class="vc-column">
						<h3>{{ 'cloud.title69' | translate }}</h3>
						<p></p>
					</div>
				</div>
				<div class="wpb_column vc_column_container">
					<div class="vc-column">
					</div>
				</div>
			</div>
		</section>
	</div>
</div>

<div id="primary" class="content-area">
	<div class="wrap">

		<app-mapa></app-mapa>

	</div>
</div>

<div class="space"></div>
<div class="space3"></div>

<div class="darkgray xback">
<div class="content-area padd">
	<div class="wrap">
		<section class="vc_section">
				<div class="fluid6">
					<div class="xcolumn_center">
						<div class="xwrapper">
							<img class="mount" src="../../../../assets/img/mount.svg" alt="">
							<h2>{{ 'cloud.title75' | translate }}</h2>
							<h4>{{ 'cloud.title76' | translate }}</h4>
							<div class="space2"></div>
							<div class="barra6">
								<div class="inside">
									<div class="box6">
										<div class="cover">
											<img class="googleCloud" src="../../../../assets/img/googleCloud.svg" alt="google">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
		</section>
	</div>
</div>
</div>






<div style="margin-bottom: -40px;">
	<app-form></app-form>
</div>
